/* eslint-disable array-callback-return */
import { cloneDeep } from "../../../../utils/cloneDeep";
export const mapSliderValues = (options = [], min, max, fieldValue) => {
  const newOptions = cloneDeep(options);
  let selectedValue = fieldValue;

  if (newOptions[0].displayText !== undefined) {
    newOptions.sort((op1, op2) => +op1.displayText - +op2.displayText);
    const difference = +newOptions[1].displayText - +newOptions[0].displayText;
    newOptions.map((option, index) => {
      option.actualValue = option.value;
      option.value = difference * (index + 1);
      option.label = option.displayText;
    });
    selectedValue =
      typeof fieldValue === "undefined"
        ? null
        : newOptions.find(x => x.actualValue === fieldValue)?.value;
  }
  let minValue = typeof min === "undefined" ? newOptions[0].value : min;
  let maxValue = typeof max === "undefined" ? newOptions[newOptions.length - 1].value : max;

  return { values: newOptions, minValue, maxValue, value: selectedValue };
};
